module.exports = __webpack_public_path__ + "img/state_account.338a4c31.svg";